<template>
    <!--票券詳情(搶券點進來) -->
    <div class="page">
        <navigation-bar Close/>
        <div class="main">
            <div class="coupon-top mb-3">
                <img :src="imgUrl">
                <div class="text-center footer-button">
                    <el-button type="primary" v-if="checkTake === 0 || isHaveCanUseInfo" round class="w-50" @click="(checkTake === 0 ? getTicket() : goUsePage())">{{takeBtn}}
                    </el-button>
                    <span class="w-100" v-else>{{takeBtn}}</span>
                </div>
            </div>
            <div class="container">
                <div class="coupon-body">
                    <div>
                        <span class="coupon-type" :title="typeName">{{typeName}}</span>
                        <div class="float-right" v-if="(ticketTypeId === ticketType.Coupon.id && !isCertificate) || ticketTypeId === ticketType.GiftPack.id || (isCertificate && stageModalStartId > 0)">
                            剩餘 <span class="red">{{remaining}}</span> {{ticketTypeItem.unit}}
                        </div>
                    </div>
                    <h4 class="mt-2">{{name}}</h4>
                    <div class="UseBranch" v-if="ticketTypeId !== ticketType.GiftPack.id">
                        <h6>適用分店</h6>
                        <div class="branch-list"
                             @click="$router.push({name: 'UsefulStoreList', query:{type: ticketTypeItem.value, id: id}})">
                            <span v-for="(item,index) in storeList "
                                  :key="index">
                              {{item.name}}
                            </span>
                        </div>
                        <div class="arrow-btn"
                             @click="$router.push({name: 'UsefulStoreList', query:{type: ticketTypeItem.value, id: id}})">
                            <i class="el-icon-arrow-right"></i></div>
                    </div>
                    <div class="UseBranch" v-if="ticketTypeId === ticketType.Coupon.id && !isCertificate">
                        <h6>生效日期</h6>
                        <div class="date">
                            {{activationText}}
                        </div>
                    </div>
                    <div class="UseBranch" v-if="ticketTypeId === ticketType.Coupon.id && !isCertificate">
                        <h6>兌換期限</h6>
                        <div class="date">
                            {{convertTimeText}}
                        </div>
                    </div>
                    <div class="UseBranch" v-if="ticketTypeId !== ticketType.Coupon.id && ticketTypeId !== ticketType.GiftPack.id">
                        <h6>發放日期</h6>
                        <div class="date">
                            {{activityEnd}} 止
                        </div>
                    </div>
                    <div v-if="giftPackContentList.length > 0" class="gift-pack-detail">
                        <div v-for="(item, index) in giftPackContentList" :key="index" class="li">
                            <h6>[{{item.kindName}}] {{item.name}} {{item.amount}} 張</h6>
                            <p><i class="el-icon-time mr-1"/>本券兌換期限{{item.convertTimeText}}</p>
                        </div>
                    </div>
                    <div class="UseBranch" v-if="isCertificate">
                        <h6>兌換場次</h6>
                        <div class="date">
                            <el-select v-model="stageModalSelectDateIndex" placeholder="請選擇日期" class="w-100"
                                       @change="selectStageModalStartDate">
                                <el-option
                                        v-for="(item, index) in stageModalDateList"
                                        :key="index"
                                        :label="item.stageCompleteFormat"
                                        :value="index">
                                    {{item.stageFormat}}<span class="small ml-3" v-if="item.intervalType === 3 || item.intervalType === 4">剩餘<span class="red">{{$public.numberFormat(item.sendMax - item.sendAmount)}}</span>張</span>
                                </el-option>
                            </el-select>
                            <el-select v-model="stageModalSelectStageIndex" v-if="stageModalStageList.length > 0" placeholder="請選擇場次" class="w-100 mt-1"
                                       @change="selectStageModalStart">
                                <el-option
                                        v-for="(item, index) in stageModalStageList"
                                        :key="index"
                                        :label="item.stageStartTime"
                                        :value="index">
                                    {{item.stageStartTime}}<span class="small ml-3">剩餘<span class="red">{{$public.numberFormat(item.sendMax - item.sendAmount)}}</span>張</span>
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div>
                    <h4 class="mt-3" v-if="content!==''">說明</h4>
                    <p>{{content}}</p>

                    <h4 class="mt-4" v-if="contentPrecautions!==''">注意事項</h4>
                    <p v-html="contentPrecautions"></p>
                </div>
            </div>
        </div>

        <comm-dialog :value="isShowDialog" :outerContent="dialogMsg" :isCancel="false"
                     :icon="icons"
                     @result="onDialogResult"></comm-dialog>

        <comm-dialog class="dialog-dark" v-if="!isLogin" :value="!isLogin" :outerContent="'請先登入'" :isModal="false"
                     :pageName="'Login'" @result="onCommDialogClose"></comm-dialog>
        <join-member-dialog :value="joinDialog.isShowDialog" :outerContent="joinDialog.dialogTitle"
                            :mainContent="joinDialog.dialogMsg" :isModal="false" :isCancel="joinDialog.cancelable"
                            @result="onJoinMemberDialogClose"/>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import CommDialog from "@/components/CommDialog";
    import JoinMemberDialog from "../../components/JoinMemberDialog";
    import * as constDefine from "@/store/constDefine";

    export default {
        name: 'TicketDetail',
        components: {
            CommDialog,
            Toast,
            JoinMemberDialog,
        },
        data() {
            return {
                parameterString: this.$route.query.p ? this.$route.query.p : '',
                id: 0,
                ticketTypeId: 0,
                objectType: 0,
                objectId: 0,
                ticketTypeItem: {
                    id: 0,
                    name: "",
                    unitName: "",
                    unit: "",
                    value: "",
                },
                name: '',
                content: '',
                contentPrecautions: '',
                activityEnd: '',
                imgUrl: '',
                typeName: '',
                storeNameList: [],
                vendorList: [],
                merchantList: [],
                shoppingAreaList: [],
                storeList: [],
                isLogin: this.$auth.isAdminLogin(),
                remaining: 0,  //剩餘張數
                isLoading: false,
                isShowDialog: false,
                dialogMsg: '',
                checkTake: 0,
                isMember: false,        //是否爲會員
                //dialog 用
                joinDialog: {
                    isShowDialog: false,
                    dialogTitle: '',
                    dialogMsg: '',
                    cancelable: false,
                },
                storeId: 0,                 //店家 ID
                brandContractStatus: 0,     //品牌合約狀態， 1:有效
                activationText: "",
                convertTimeText: "",
                ticketType: {...constDefine.TicketType},
                giftPackContentList: [],
                isCertificate: false,
                stageModalSelectDateIndex: '',
                stageModalDateList: [],
                stageModalStartId: '',
                stageModalSelectStageIndex: '',
                stageModalStageList: [],
                originCheckTake: 0,
                icons: require('@/assets/images/dialog_question.svg'),
                isHaveCanUseInfo: false,
                isGot: false,
            }
        },
        computed: {
            takeBtn: function () {
                return ["我要領取", "無法領取", this.ticketTypeItem.unitName + "已領完", "領取時間已結束", "-已領取-", this.ticketTypeItem.name + "組數用完"][this.checkTake];
            }
        },
        created() {
            if (this.parameterString !== "") {
                let parameterObj = this.$crypto.decryptObjectText(this.parameterString)
                this.id = parameterObj.id;
                this.ticketTypeId = parameterObj.ticketTypeId;
                this.objectType = parameterObj.objectType || 0;
                this.objectId = parameterObj.objectId || 0;

                for (let index in constDefine.TicketType) {
                    let item = constDefine.TicketType[index];
                    if (item.id === this.ticketTypeId) {
                        this.ticketTypeItem = item
                        break;
                    }
                }
            }
        },
        mounted() {
            if (this.isLogin) {
                if (this.ticketTypeId > 0) {
                    this.setupData();
                }
            }
        },
        methods: {
            setupData() {
                let self = this;
                let getInfoFunc = function () {
                };

                //取得優惠券資料
                if (this.ticketTypeId === constDefine.TicketType.Coupon.id) {
                    getInfoFunc = () => {
                        return this.callGetCouponInfoByIdApi(0, 0)
                    };
                    //取得集點卡資料
                } else if (this.ticketTypeId === constDefine.TicketType.LoyaltyCard.id) {
                    getInfoFunc = () => {
                        return this.callGetLoyaltyCardInfoByIdApi()
                    };
                    //取得紅利點數資料
                } else if (this.ticketTypeId === constDefine.TicketType.RewardPoint.id) {
                    getInfoFunc = () => {
                        return this.callGetRewardPointInfoByIdApi()
                    };
                    //取得禮包資料
                } else if (this.ticketTypeId === constDefine.TicketType.GiftPack.id) {
                    getInfoFunc = () => {
                        return this.callGetGiftPackInfoByIdApi()
                    };
                }

                let asyncRun = async () => {
                    await Promise.all([getInfoFunc()])
                }

                asyncRun()
                    .then(
                        () => {
                            return self.callIsContractAvailableApi(self.storeId);
                        }
                    )
                    .catch((error) => {
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

            },
            /** 我要領取  **/
            getTicket() {
                if (this.brandContractStatus === 1) {
                    this.isLoading = true;
                    switch (this.ticketTypeId) {
                        case constDefine.TicketType.Coupon.id:
                            if (this.isCertificate && (this.stageModalStartId === '' || this.stageModalStartId === 0)) {
                                this.showDialog("請選擇場次");
                                this.isLoading = false;
                                return false
                            }

                            this.callGetCouponApi();
                            break;
                        case constDefine.TicketType.LoyaltyCard.id:
                            this.callGetLoyaltyCardApi();
                            break;
                        case constDefine.TicketType.RewardPoint.id:
                            this.callGetRewardPointApi();
                            break;
                        case constDefine.TicketType.GiftPack.id:
                            this.callGetGiftPackApi();
                            break;
                        default:
                            this.isLoading = false;
                            break;
                    }

                } else {
                    this.showDialog("該" + this.ticketTypeItem.name + "已經無法使用，若有任何使用疑問請詢問原發放店家");
                }
            },
            /** 我要領取優惠券  **/
            callGetCouponApi() {
                this.$http.fetchWithAuth`GetCoupon${{
                    id: this.id,
                    sendObject: this.objectType,
                    sendObjectId: this.objectId,
                    stageId: Number(this.stageModalStartId),
                }}${json => {
                    if (json.data !== null && json.data !== '') {
                        this.checkTake = Number(json.data.checkTake);
                        this.isGot = json.status
                        if (json.status) {
                            this.remaining = json.data.residue;
                            this.showDialog(json.message);
                            if(this.isCertificate) {
                                this.clearCertificateStage(false)
                            }

                            this.callGetCouponInfoByIdApi(0, 0);
                        } else {
                            this.showDialog('抱歉：' + json.message);
                        }
                        //如果是商圈的需要靠這樣刷新資料，因為那邊有緩存
                        this.$store.commit("getOffersList", {
                            objectType: this.objectType,
                            objectId: this.objectId,
                        })
                    }
                    this.isLoading = false;
                }}}`;
            },
            /** 我要領取集點卡  **/
            callGetLoyaltyCardApi() {
                this.$http.fetchWithAuth`GetLoyaltyCard${{
                    id: this.id,
                    storeId: this.storeId,
                    sendObject: constDefine.MerchantType.Store,
                    sendObjectId: this.storeId,
                }}${json => {
                    if (json.data !== null && json.data !== '') {
                        this.checkTake = Number(json.data.checkTake);
                        this.isGot = json.status
                        if (json.status) {
                            this.showDialog(json.message);
                            this.callGetLoyaltyCardInfoByIdApi();
                        } else {
                            this.showDialog('抱歉：' + json.message);
                        }
                    }
                    this.isLoading = false;
                }}}`;
            },
            callGetGiftPackApi() {
                this.$http.fetchWithAuthEncrypt`GetGiftPack${{
                    id: this.id,
                    sendObject: this.objectType,
                    sendObjectId: this.objectId,
                }}${json => {
                    this.checkTake = Number(json.data.checkTake);
                    this.isGot = json.status
                    if (json.status) {
                        this.showDialog(json.message);
                        this.callGetGiftPackInfoByIdApi();
                    } else {
                        this.showDialog('抱歉：' + json.message);
                    }
                    //如果是商圈的需要靠這樣刷新資料，因為那邊有緩存
                    this.$store.commit("getOffersList", {
                        objectType: this.objectType,
                        objectId: this.objectId,
                    })

                    this.isLoading = false;
                }}}`;
            },
            showDialog(msg) {
                this.icons = require('@/assets/images/dialog_question.svg')
                if(this.isGot) {
                    this.icons = require('@/assets/images/dialog_ticket.svg')
                }

                this.dialogMsg = msg;
                this.isShowDialog = true;
            },
            onDialogResult() {
                this.isShowDialog = false;
                if (this.isHaveCanUseInfo && this.isGot) {
                    this.isGot = false;
                    this.goUsePage()
                }
            },
            /** 呼叫 取得優惠券資訊 api */
            callGetCouponInfoByIdApi(lng, lat) {
                let self = this;
                self.isLoading = true;

                return new Promise(function (resolve, reject) {

                    self.$http.fetchWithAuth`GetCouponInfoById${{
                        id: self.id,
                        lng: lng,
                        lat: lat,
                        executeType: "getCoupon",
                        executeObject: self.objectType,
                        executeId: self.objectId,
                    }}${json => {
                        self.isLoading = false;
                        if (json.data !== null && json.data !== '') {
                            self.id = json.data.id;
                            self.name = json.data.name;
                            self.content = json.data.content;
                            self.contentPrecautions = json.data.contentPrecautions;
                            self.activityEnd = json.data.activityEnd;
                            self.imgUrl = json.data.imgUrl;
                            self.typeName = json.data.typeName;
                            self.storeNameList = json.data.storeNameList;
                            self.vendorList = json.data.vendorList;
                            self.merchantList = Object.values(json.data.merchantList).flat(2);
                            self.shoppingAreaList = Object.values(json.data.shoppingAreaList).flat(2);
                            self.checkTake = json.data.checkTake;
                            self.storeId = json.data.storeId;
                            self.activationText = json.data.activationText;
                            self.convertTimeText = json.data.convertTimeText;
                            self.isCertificate = json.data.isCertificate;
                            self.stageModalDateList = json.data.certificateDateList;
                            self.isHaveCanUseInfo = json.data.isHaveCanUseInfo;

                            self.storeList = []
                            self.storeNameList.forEach(item => {
                                self.storeList.push({
                                    "name": item.name === "" ? item.brandName : item.brandName + "-" + item.name,
                                })
                            })
                            self.merchantList.forEach(item => {
                                self.storeList.push({
                                    "name": item.merchantName === "" ? item.brandName : (item.brandName === "" ? item.merchantName : item.brandName + "-" + item.merchantName),
                                })
                            })
                            self.vendorList.forEach(item => {
                                self.storeList.push({
                                    "name": item.name,
                                })
                            })
                            self.shoppingAreaList.forEach( item => {
                                self.storeList.push({
                                    "name": item.name,
                                })
                            })

                            if (json.data.residue === undefined || json.data.residue === null) {
                                self.remaining = 0;
                            } else {
                                self.remaining = json.data.residue;
                            }

                            if (json.data.checkTake === undefined || json.data.checkTake === null) {
                                self.checkTake = 1;
                            } else {
                                self.checkTake = json.data.checkTake;
                            }

                            self.originCheckTake = self.checkTake

                            resolve();

                        } else {
                            reject(json.message);
                        }
                    }}}`
                });
            },
            /** 呼叫 取得集點卡資訊 api */
            callGetLoyaltyCardInfoByIdApi() {
                let self = this;
                self.isLoading = true;

                return new Promise(function (resolve, reject) {
                    self.$http.fetchWithAuth`GetLoyaltyCardInfoById${{
                        id: self.id,
                    }}${json => {
                        self.isLoading = false;
                        if (json.data !== null && json.data !== '') {
                            self.id = json.data.id;
                            self.name = json.data.name;
                            self.content = json.data.content;
                            self.contentPrecautions = json.data.contentPrecautions;
                            self.activityEnd = json.data.activityEnd;
                            self.imgUrl = json.data.imgUrl;
                            self.typeName = json.data.typeName;
                            self.storeNameList = json.data.storeNameList;
                            self.checkTake = json.data.checkTake;
                            self.storeId = json.data.storeId;
                            self.isHaveCanUseInfo = json.data.isHaveCanUseInfo;

                            self.storeList = []
                            self.storeNameList.forEach(item => {
                                self.storeList.push({
                                    "name": item.name === "" ? item.brandName : item.brandName + "-" + item.name,
                                })
                            })

                            resolve();

                        } else {
                            reject(json.message);
                        }
                    }}}`
                })
            },
            callGetGiftPackInfoByIdApi() {
                let self = this;
                self.isLoading = true;

                return new Promise(function (resolve, reject) {
                    self.$http.fetchWithAuthEncrypt`GetGiftPackInfoById${{
                        id: self.id,
                        executeType: "getGiftPack",
                        executeObject: self.objectType,
                        executeId: self.objectId,
                    }}${json => {
                        self.isLoading = false;
                        if (json.status) {
                            let data = json.data
                            let giftPackInfo = data.giftPackInfo

                            self.id = giftPackInfo.id;
                            self.name = giftPackInfo.name;
                            self.content = giftPackInfo.content;
                            self.contentPrecautions = giftPackInfo.contentPrecautions;
                            self.activityEnd = giftPackInfo.activityEnd;
                            self.imgUrl = giftPackInfo.imgUrl;
                            self.typeName = giftPackInfo.typeName;
                            self.remaining = giftPackInfo.residue;
                            self.giftPackContentList = giftPackInfo.giftPackContentList;

                            self.checkTake = data.checkTake;
                            self.isHaveCanUseInfo = data.isHaveCanUseInfo;

                            resolve();

                        } else {
                            reject(json.message);
                        }
                    }}}`
                })
            },
            /** 品牌合約是否有效 */
            callIsContractAvailableApi: function (storeId) {

                let self = this;
                self.isLoading = true;
                return new Promise(function (resolve, reject) {
                    self.isLoading = false;
                    self.brandContractStatus = 1;
                    resolve();
                    // if(storeId !== 0) {
                    //   self.$http.fetch`IsBrandContractAvailable${{
                    //       'storeId': storeId,
                    //   }} ${json => {
                    //       self.isLoading = false;
                    //       if (json.status) {
                    //           if (self.$public.notNull(json.data)) {
                    //               self.brandContractStatus = json.data.contractStatus;
                    //               resolve();
                    //           }
                    //       }
                    //       reject(json.message);
                    //   }}}`;
                    // } else {
                    //   self.isLoading = false;
                    //   self.brandContractStatus = 1;
                    //   resolve();
                    // }
                });
            },

            /** 是否加入會員 */
            isJoinMember: function () {
                let self = this;
                //取得店家資訊
                self.isLoading = true;
                self.$http.fetch`IsAddStore${{
                    id: self.id,
                }} ${json => {
                    self.isMember = json.status;
                }}`;
            },

            /** 加入成爲會員 */
            addMember: function (storeId) {
                let self = this;
                return new Promise(function (resolve, reject) {
                    self.$http.fetchWithAuth`AddStore${{
                        id: storeId
                    }} ${json => {
                        self.isMember = json.status;

                        if (json.status) {
                            //完成
                            resolve();
                        } else {
                            reject('無法加入會員:' + json.message);
                        }
                    }}`;
                });
            },

            /** 加入會員訊息 dialog */
            showJoinMemberDialog: function (title, msg, cancelable = false) {
                this.joinDialog.cancelable = cancelable;
                this.joinDialog.dialogTitle = title;
                this.joinDialog.dialogMsg = msg;
                this.joinDialog.isShowDialog = true;
            },

            /** JoinMemberDialog 關閉事件 */
            onJoinMemberDialogClose: function (result) {
                this.joinDialog.isShowDialog = false;

                if (result) {
                    if (this.id > 0) {
                        let self = this;
                        self.isLoading = true;
                        //加入會員
                        self.addMember(self.id)
                            .then(() => {
                                self.isLoading = false;
                                //加入成功
                                self.showDialomutationTypesg(`加入會員成功`);
                            })
                            .catch((error) => {
                                self.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                }
            },

            /** dialog 關閉事件 */
            onCommDialogClose(result) {
                if (result) {
                    this.$router.push({name: 'Login'});
                } else {
                    this.$router.go(-1)
                }
            },
            /** 呼叫 取得紅利點數資訊 api */
            callGetRewardPointInfoByIdApi() {
                let self = this;
                self.isLoading = true;

                return new Promise(function (resolve, reject) {
                    self.$http.fetchWithAuthEncrypt`GetRewardPointInfoById${{
                        id: self.id,
                    }}${json => {
                        self.isLoading = false;
                        if (json.data !== null && json.data !== '') {
                            self.id = json.data.id;
                            self.name = json.data.name;
                            self.content = json.data.content;
                            self.contentPrecautions = json.data.contentPrecautions;
                            self.activityEnd = json.data.activityEnd;
                            self.imgUrl = json.data.imgUrl;
                            self.typeName = json.data.typeName;
                            self.storeNameList = json.data.storeNameList;
                            self.checkTake = json.data.checkTake;
                            self.storeId = json.data.storeId;
                            self.isHaveCanUseInfo = json.data.isHaveCanUseInfo;

                            self.storeList = []
                            self.storeNameList.forEach(item => {
                                self.storeList.push({
                                    "name": item.name === "" ? item.brandName : item.brandName + "-" + item.name,
                                })
                            })

                            resolve();

                        } else {
                            reject(json.message);
                        }
                    }}}`
                })
            },
            /** 我要領取紅利點數  **/
            callGetRewardPointApi() {
                this.$http.fetchWithAuthEncrypt`GetRewardPoint${{
                    id: this.id,
                    storeId: this.storeId,
                    sendObject: constDefine.MerchantType.Store,
                    sendObjectId: this.storeId,
                }}${json => {
                    if (json.data !== null && json.data !== '') {
                        this.checkTake = Number(json.data.checkTake);
                        this.isGot = json.status
                        if (json.status) {
                            this.showDialog(json.message);
                            this.callGetRewardPointInfoByIdApi();
                        } else {
                            this.showDialog('抱歉：' + json.message);
                        }
                    }
                    this.isLoading = false;
                }}}`;
            },
            selectStageModalStartDate() {
                let self = this

                self.remaining = 0
                self.stageModalStartId = ''
                self.stageModalSelectStageIndex = ''
                self.stageModalStageList = []

                let dateItem = self.stageModalDateList[self.stageModalSelectDateIndex]
                if (dateItem.intervalType === 1 || dateItem.intervalType === 2) {
                    self.$http.fetchWithAuth`GetCouponCertificateInfo${{
                        "id": self.id,
                        "searchStartDate": dateItem.stageStartAt,
                        "isStageList": true,
                    }}
                    ${json => {
                        if (json.status) {
                            let data = json.data;
                            self.stageModalStageList = data.stageList;
                        } else {
                            self.$public.showNotify(json.message, json.status);
                        }
                    }}`;
                } else {
                    self.stageModalStartId = dateItem.stageId
                    self.remaining = self.$public.numberFormat(dateItem.sendMax - dateItem.sendAmount)
                    self.checkGetCertificateStage()
                }
            },
            selectStageModalStart() {
                let self = this
                let stageItem = self.stageModalStageList[self.stageModalSelectStageIndex]
                self.stageModalStartId = stageItem.stageId
                self.remaining = self.$public.numberFormat(stageItem.sendMax - stageItem.sendAmount)
                self.checkGetCertificateStage()
            },
            checkGetCertificateStage() {
                let self = this
                if(self.originCheckTake === 0) {
                    self.$http.fetchWithAuth`CheckGetCertificateStage${{
                        "id": self.id,
                        "StageId": self.stageModalStartId,
                    }}
                        ${json => {
                        if (json.status) {
                            let data = json.data;
                            self.checkTake = (data.status ? 0 : 4)
                            self.isHaveCanUseInfo = json.data.isHaveCanUseInfo;
                        } else {
                            self.$public.showNotify(json.message, json.status);
                        }
                    }}`;
                }
            },
            clearCertificateStage(isClearStartId = true) {
                this.stageModalSelectDateIndex = ''
                this.stageModalDateList = []
                this.stageModalSelectStageIndex = ''
                this.stageModalStageList = []
                if (isClearStartId) {
                    this.stageModalStartId = ''
                }
            },
            goUsePage() {
                switch (this.ticketTypeId) {
                    case constDefine.TicketType.Coupon.id:
                        if (this.isCertificate) {
                            if (this.stageModalStartId === "") {
                                this.showDialog("請選擇場次");
                            } else {
                                this.$router.push({name: 'CouponPage', query: {'id': 0, 'couponId': this.id, 'count': 0, 'activeCategory': '', 'stageId': this.stageModalStartId}});
                            }
                        } else {
                            this.$router.push({name: 'CouponPage', query: {'id': 0, 'couponId': this.id, 'count': 0, 'activeCategory': ''}});
                        }
                        break;
                    case constDefine.TicketType.LoyaltyCard.id:
                        this.$router.push({name: 'LoyaltyCardPage', query: {id: this.id, activeCategory: ''}})
                        break;
                    case constDefine.TicketType.RewardPoint.id:
                        var dataToken = this.$crypto.objectToURIComponent({
                            "usedType": "BonusPointsPage",
                            "id": this.id,
                        })

                        this.$router.push({name: 'BonusPointsPage', query: {dataToken: dataToken}})
                        break;
                    case constDefine.TicketType.GiftPack.id:
                        this.$router.push({name: 'CouponPage', query: {'id': 0, 'couponId': this.id, 'count': 0, 'activeCategory': '', 'offersType': constDefine.TicketType.GiftPack.id}});
                        break;
                }
            },
        }
    }

</script>

<style lang="less" scoped src="../../less/gift.less"/>